module.exports = __webpack_public_path__ + "public/1.0.1_200686/img/从DA前等离子清洗连到LA3大连线.2c184fee.jpg";